<template>
    <div>
        <div class="row">
            <!-- <v-table :column="colunas" :data="dataComputed" :actions="actionsTable"></v-table> -->
        </div>
        <b-row>
            <b-col>
                <h1>Pedidos</h1>
            </b-col>
        </b-row>
        <b-row align-v="end">
            <b-col class="col-md-2">
                <label for="">De</label>
                <date-picker :disabled="loading" v-model="fromDate" :config="datePickerConfig"></date-picker>
            </b-col>
            <b-col class="col-md-2">
                <label for="">Até</label>
                <date-picker :disabled="loading" v-model="toDate" :config="datePickerConfig"></date-picker>
            </b-col>
            <b-col class="col-md-2">
                <label for="">Distribuidor</label>
                <b-form-input :disabled="loading" @keyup.enter="loadPedidos" v-model="distribuidor"
                    placeholder="Nome ou Código"></b-form-input>
            </b-col>
            <b-col class="col-md-1">
                <label for="">Estado</label>
                <b-form-select v-model="estado" :options="estados" :disabled="loading"></b-form-select>
            </b-col>
            <b-col class="col-md-1">
                <label for="">Campanha</label>
                <b-form-select v-model="campanha" :options="campanhas" :disabled="loading"></b-form-select>
            </b-col>
            <b-col class="text-left">
                <b-button :disabled="loading" variant="primary" @click="loadPedidos(false)">
                    <i class="fa fa-search"></i> Buscar
                </b-button>
                <b-button variant="success" @click="loadPedidos(true)" v-if="!loading" :disabled="loading">
                    <i class="far fa-file-excel"></i> Exportar
                </b-button>
                <!-- <b-button variant="success" v-if="pedidos.length > 0 && !loading" :disabled="loading">
                    <json-excel :data="pedidos" v-if="pedidos.length > 0" worksheet="Pedidos" :name="filename">
                        <i class="far fa-file-excel"></i> Exportar
                    </json-excel>
                </b-button> -->
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <b-card>
                    <b-table :items="pedidos" :busy="loading" :fields="fields" stacked="md" show-empty small striped empty-text="Nenhum pedido encontrado!">
                        <template #table-busy>
                            <div class="text-center text-primary my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong> Carregando Pedidos...</strong>
                            </div>
                        </template>
                    </b-table>
                    <b-row>
                        <b-col class="col-md-8">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                                size="sm" align="fill" class="my-0"></b-pagination>
                        </b-col>
                        <b-col class="text-right">
                            Total de Distribuidores: {{ pedidos.length }}
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
export default {
    components: {
        JsonExcel
    },
    data() {
        return {
            datePickerConfig: {
                'format': 'D/MM/YYYY',
                'showClose': true
            },
            fields: [
                { key: 'codigo', label: 'Código', sortable: true },
                { key: 'nome', label: 'Distribuidor', sortable: true },
                { key: 'campanha', label: 'Campanha', sortable: true },
                { key: 'classe', label: 'Classe', sortable: true },
                { key: 'estado', label: 'Estado', sortable: true },
                { key: 'cidade', label: 'Cidade', sortable: true },                
                { key: 'itens', label: 'Itens', sortable: true },
                { key: 'aberto', label: 'Abertos', sortable: true },
                /*{ key: 'ENVIADO', label: 'Enviados', sortable: true },*/
                { key: 'deletado', label: 'Deletados', sortable: true },
            ],
            loading: false,
            toDate: "",
            fromDate: "",
            pedidos: [],
            perPage: 20,
            currentPage: 1,
            distribuidor: '',
            estados: [],
            estado: null,
            totalRows: 0,
            campanhas: [],
            campanha: null,
        }
    },
    methods: {
        async getCampanhas() {
            var vm = this;
            vm.campanhas = [];
            await axios
                .get("/adm/campanhas/list")
                .then((response) => {
                    vm.campanhas = []
                    response.data.forEach((el) => {
                        vm.campanhas.push({
                            value: el.id,
                            text: el.codigo,
                        });
                    });
                    vm.campanha = vm.campanhas[0].value;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getEstados() {
            const vm = this;
            axios("/estados")
                .then((response) => {
                    vm.estados = [{ value: null, text: 'TODOS' }]
                    response.data.forEach((a, b) => {
                        vm.estados.push({
                            value: a.uf,
                            text: a.uf
                        })
                    })
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async initDates() {
            let m = moment();
            m.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            this.toDate = moment();
            this.toDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            this.fromDate = m;
            this.fromDate.subtract(5, 'day');
            this.fromDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
            await this.getCampanhas();
            await this.getEstados();
            //this.loadPedidos(false);
        },
        loadPedidos(excel) {
            const vm = this;
            let data = {
                from: this.fromDate,
                to: this.toDate,
                currentPage: this.currentPage,
                perPage: this.perPage,
                distribuidor: this.distribuidor,
                campanha: this.campanha,
                estado: this.estado,
                excel: excel
            };
            vm.loading = true;

            let params = {
                params: data
            };

            if(excel){
                params.responseType = 'blob';
            }

            axios.get('/adm/pedidos/list', params)
            .then((response) => {
                if(excel){
                    const link = window.document.createElement('a');
                    link.href = window.URL.createObjectURL(response.data);
                    link.download = 'exportar_pedidos.xlsx';
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                }else{
                    vm.pedidos = response.data.data;
                    vm.totalRows = response.data.total;                
                }
            }).catch((error) => {
                vm.$swal.fire({
                    title: "Atenção",
                    html: error.response.data,
                    icon: "error",
                })
                console.log(error);
            }).finally(() => {
                vm.loading = false
            });
        },
        formatDate(date) {
            if (!date) {
                return "";
            }
            return moment(date).format("D/MM/Y");
        },
    },
    computed: {
        filename() {
            const data = new Date();
            return `${data.getTime()}.xls`;
        },
        dataComputed() {
            return this.pedidos;
        }
    },
    watch:{
        currentPage() {
            this.loadPedidos(false)
        }
    },
    mounted() {
        this.initDates();
    }
}

</script>


<style scoped="">
.btn-search {
    margin-top: 25px;
}

.to-print {
    display: none;
}

@media print {
    .to-print {
        display: block !important;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_pedidos/Main.vue